export default __webpack_public_path__ + "static/media/EmptyNotification.6c429abb.svg";